import { RouterProvider, createBrowserRouter } from "react-router-dom";
import { AuthProvider } from "./features/auth/AuthContext";
import routes from "./routes";

const router = createBrowserRouter(routes);

const App = () => (
  <AuthProvider>
    <RouterProvider router={router} />
  </AuthProvider>
);

export default App;
